<template>
    <v-card class="pa-3">
        <v-card-title class="headline px-0 mb-2">{{
            student.studentID ? "Update Student" : "New Student"
        }}</v-card-title>
        <v-form ref="form">
            <v-text-field
                autocomplete="new-password"
                label="Name"
                v-model="student.engName"
                ref="engName"
                :rules="required"
            ></v-text-field>
            <v-text-field
                autocomplete="new-password"
                label="Hebrew Name"
                v-model="student.hebName"
                ref="hebName"
                :rules="required"
            ></v-text-field>
            <v-menu
                v-model="datePickerMenu"
                :close-on-content-click="false"
                full-width
                max-width="290"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        :value="formatedDate"
                        label="Date Of Birth"
                        v-on="on"
                        ref="dob"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="student.dob"
                    @change="datePickerMenu = false"
                ></v-date-picker>
            </v-menu>
            <v-autocomplete
                autocomplete="new-password"
                label="Class"
                v-model="student.class"
                ref="class"
                :rules="required"
                :items="
                    gradesSetup
                        .filter((g) => g.isDayCampAvail)
                        .map((g) => g.grade)
                "
            ></v-autocomplete>
        </v-form>
        <v-card-actions class="mr-0 mt-2">
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closeNewStudentModal"
                >Cancel</v-btn
            >
            <v-btn color="success" @click="save">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";

export default {
    props: {
        gradesSetup: Array,
        closeNewStudentModal: Function,
        onCreated: Function,
        account: Object,
    },
    data() {
        return {
            student: {
                studentID: "",
                hebName: "",
                engName: "",
                dob: "",
                class: "",
                familyID: "",
            },

            processing: false,
            datePickerMenu: false,

            required: [(value) => !!value || "Required."],
        };
    },
    async created() {},
    computed: {
        formatedDate() {
            return this.student.dob ? moment(this.student.dob).format("L") : "";
        },
    },
    methods: {
        prefill(student) {
            this.student.studentID = student.studentID;
            this.student.hebName = student.hebName;
            this.student.engName = student.engName;
            this.student.dob = new Date(student.dob)
                .toISOString()
                .substr(0, 10);
            this.student.class = student.class;
        },
        clear() {
            this.student.hebName = "";
            this.student.engName = "";
            this.student.dob = "";
            this.student.class = "";
            this.student.familyID = "";
        },
        async save() {
            if (!moment(this.student.dob).isValid()) {
                this.$notify({
                    text: "Invalid Date",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.$refs.form.validate(true)) return;

            this.processing = true;

            this.student.familyID = this.account.accountID;

            try {
                const student = await this.$http.post(
                    "api/lapidusDayCamp/saveNewStudent?user=" +
                        this.$store.state.authentication.user,
                    this.student,
                );

                this.onCreated(student);

                this.clear();

                this.processing = false;
            } catch (e) {
                this.processing = false;

                return;
            }
        },
    },
};
</script>
